import { createContext, useContext } from "react";

/**
 * The hint rung: where a {@link PInfo} bubble paints — above the AI drawer /
 * rail (z-10000), below toasts (z-10002). It is the bubble's own `z-[10001]`
 * class; a hint layer only ever RAISES it.
 */
export const TOOLTIP_Z_DEFAULT = 10001;

/**
 * The z a surface's hints paint at. A surface that sits ABOVE the default
 * rung — the guest popup the send dialog's opt-in list raises to z-10070,
 * the dialogs it opens on `overGuestPopup` (z-10080) — painted every hint of
 * its own UNDER itself (audit hop3 r2 M1 / L3). Such a surface hands its
 * subtree a layer one above its own z ({@link hintZAbove}); React context
 * crosses the bubble's portal to <body>, so the bubble reads it.
 */
export const TooltipLayerContext = createContext<number>(TOOLTIP_Z_DEFAULT);

export const useTooltipZ = (): number => useContext(TooltipLayerContext);

/**
 * The hint rung a surface with this z class hands its children: one above
 * its own z when that is above the default rung; undefined when its hints
 * already paint above it. Reads `z-[N]` and `z-N`.
 */
export function hintZAbove(zClass: string | undefined): number | undefined {
  const m = /(?:^|\s)z-\[?(\d+)\]?(?=\s|$)/.exec(zClass ?? "");
  if (!m) return undefined;
  const z = Number(m[1]);
  return z > TOOLTIP_Z_DEFAULT ? z + 1 : undefined;
}
